export const ROLE_KEY = ["ROLES"];

export const ROLES_CACHE_KEY = (workspaceId: string) => [
  ...ROLE_KEY,
  workspaceId,
];

export const PERMISSION_CATALOG_CACHE_KEY = ["PERMISSION_CATALOG"];
